import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { AnaClubRoutes } from '../modules/ana-club/ana-club.app-manager-routes';

export class AnaClubEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [
      createMenuCmdField(AnaClubRoutes.AnaKennelClubList),
      createMenuCmdField(AnaClubRoutes.GenLwWalletRichiestaList)
    ];
  }
}
